var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 860,
    viewBox: "0 0 1440 860",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_31586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 860
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 859.5,
    fill: "url(#paint0_radial_816_31586)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_31586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    fill: "#2970FF",
    fillOpacity: 0.15,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 14.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 132.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    fill: "#2970FF",
    fillOpacity: 0.15,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    fill: "#2970FF",
    fillOpacity: 0.15,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 251.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 369.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    fill: "#2970FF",
    fillOpacity: 0.15,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 488.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 606.75,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.75,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.75,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.25,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.75,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 896.25,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.75,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1133.25,
    y: 725.25,
    width: 118.5,
    height: 118.5,
    stroke: "#2970FF",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_816_31586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 429.75) rotate(90) scale(529.785 887.598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPattern);
export default __webpack_public_path__ + "static/media/background-pattern.f4f13c1d0848760fc3d9d9f9d93852ff.svg";
export { ForwardRef as ReactComponent };